import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

function EsperienzeLavorativePerUtente() {

    const [esperienzeLavorative, setEsperienzeLavorative] = useState({})
    const getAssistente = useSelector(state => state.wizardReducer)

    useEffect(() => {
        if (getAssistente && getAssistente.esperienzeLavorative) {
            setEsperienzeLavorative(getAssistente.esperienzeLavorative)
        }
    }, [])

    return (
        <div>
            {esperienzeLavorative.colf && esperienzeLavorative.colf.colfCheck ?
                <div className={"row"}>
                    <span style={{fontSize:"20px"}}>
                        <b>Colf: </b>{esperienzeLavorative.colf.anniColf === "1" ? "1-2 Anni" : esperienzeLavorative.colf.anniColf === "2" ? "2-3 Anni" : "più di 5 Anni"}
                    </span>
                </div>
                : <></>}
            {esperienzeLavorative.assistente && esperienzeLavorative.assistente.assistenteFamiliare ?
                <div className={"row"}>
                    <span style={{fontSize:"20px"}}>
                       <b>Assistente Familiare: </b>{esperienzeLavorative.assistente.anniAssistente === "1" ? "1-2 Anni" : esperienzeLavorative.assistente.anniAssistente === "2" ? "2-3 Anni" : "più di 5 Anni"}
                    </span>
                </div>
                : <></>}
            {esperienzeLavorative.operatore && esperienzeLavorative.operatore.operatoreSocioSanitario ?
                <div className={"row"}>
                    <span style={{fontSize:"20px"}}>
                       <b>Operatore Socio Sanitario: </b>{esperienzeLavorative.operatore.anniOperatore === "1" ? "1-2 Anni" : esperienzeLavorative.operatore.anniOperatore === "2" ? "2-3 Anni" : "più di 5 Anni"}
                    </span>
                </div>
                : <></>}
            {esperienzeLavorative.ospedaliero && esperienzeLavorative.ospedaliero.assistenteOspedaliero ?
                <div className={"row"}>
                    <span style={{fontSize:"20px"}}>
                       <b>Assistente Ospedaliero: </b>{esperienzeLavorative.ospedaliero.anniOspedaliero === "1" ? "1-2 Anni" : esperienzeLavorative.ospedaliero.anniOspedaliero === "2" ? "2-3 Anni" : "più di 5 Anni"}
                    </span>
                </div>
                : <></>}
        </div>)


}

export default EsperienzeLavorativePerUtente